export class azureADInterface {
    static promptLoginPage = async () => { }
    static refreshToken = async refreshToken => { }
    static getUserFromToken = token => { }
}
